<template>
  <div class="diadin">
    <div class="tabs" style="margin-bottom: 30px;">
      <div class="tab" :class="active == 0 ? 'active' : ''" @click="setActive(0)"> {{ $t('menu.Bymodel') }}
        <p class="line" v-if="active == 0">

        </p>
      </div>
      <div class="tab" :class="active == 1 ? 'active' : ''" @click="setActive(1)"> {{ $t('menu.ByVIN') }}
        <p class="line" v-if="active == 1">

        </p>
      </div>
      <div class="tab" :class="active == 2 ? 'active' : ''" @click="setActive(2)"> {{ $t('menu.Bypart') }}
        <p class="line" v-if="active == 2">

        </p>
      </div>
    </div>
    <div v-if="active == 0">
      <Vehicle></Vehicle>
    </div>
    <div v-if="active == 1">
      <vin></vin>
    </div>
    <div v-if="active == 2">
      <contlist></contlist>
    </div>

    <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item v-if="active == 0">
        <el-select v-model="formInline.category" placeholder="车型" @change="changeCheXing">
          <el-option v-for="item in list" :label="item.seriesModel" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="active == 0">
        <el-button type="primary" @click="onSubmit">搜索</el-button>
      </el-form-item>

      <el-form-item v-if="active == 1">
        <el-input style="width: 300px" placeholder="车架号" v-model="formInline.title"></el-input>
      </el-form-item>

      <el-form-item v-if="active == 2">
        <el-input style="width: 300px" placeholder="配件名称/编码" v-model="formInline.title"></el-input>
      </el-form-item>

      <el-form-item v-if="active == 1">
        <el-button type="primary" @click="onSubmit(1)">搜索</el-button>
      </el-form-item>

      <el-form-item v-if="active == 2">
        <el-button type="primary" @click="onSubmit(2)">搜索</el-button>
      </el-form-item>

      <div style="width: 100%;height: 1px; background-color: #eee;margin-bottom: 30px;"></div>

    </el-form>
    <div class="box" style="display: flex;height: 900px;">
      <div class="leftbox" v-if="active == 0 || active == 1">
        <div class="chexing">{{ seriesModel }}</div>
        <div class="fg"></div>
        <div v-for="(item, index) in mation" :key="index" style="padding-left: 20px;">
          <div class="big-pj" :class="categoryName == item.categoryName ? 'acta' : ''"
            @click="onsubtitle(item.id, item.categoryName)">{{ item.categoryName }}</div>
        </div>
      </div>

      <div class="center-box" style="width: 80%;height: 80%;" v-if="active == 0 || active == 1">
        <div class="block" style="width: 100%;height: 100%;">
          <el-image :src="urlItem">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

        <div style="display: flex; justify-content: center;">
          <img v-for="item in urlList" :src="item" :class="item == urlItem ? 'acttimg' : ''" class="img-item"
            @click="setImgUrl(item)">
        </div>
      </div>



      <div class="rightbox" style="min-width: 25vw; border: 1px solid #eee;">
        <div class="chexing" v-if="active != 2">{{ categoryName }}</div>
        <div class="fg"></div>
        <div class="infinite-list-wrapper" style="
            overflow: auto;
            height: 100%;
            width: 100%;
          ">
          <ul class="list" v-infinite-scroll="load" infinite-scroll-immediate="false" :infinite-scroll-distance="2"
            :infinite-scroll-disabled="disabled">
            <li v-if="active != 2" v-for="(item, index) in mation1" :key="index" class="list-item">
              <div class="right-item" style="width: 100%;height: 100%;">
                <div class="left">
                  <template>
                   
                  </template>
<div class="product-info">
  <div class="name-info">
    <div class="name-info-1">
      <div class="index">{{ item.diagramNum }}</div>
      <p style="color: #222222;font-weight: 550;display: flex;    flex-wrap: nowrap;">{{ item.partName
        }}</p>

    </div>

    <p style="margin-bottom: 10px;">{{ item.partNumber }}</p>

  </div>
</div>


<div v-if="active == 2" style="margin-left: 80px;min-width: 30%;margin-bottom: 10px;">{{
  item.mcSeriesModel.seriesModel
  }}-{{
  item.partCategory.categoryName }}</div>
<div class="num-box1">
  <el-input-number v-model="item.buyNum" :min="item.minPurchaseQuantity" size="mini"
    @change="changeNum($event, item.minPurchaseQuantity, index,)"></el-input-number>

</div>
</div>
<div class="price" :class="active != 2 ? 'max-width' : ''">￥{{
  item.purchasePriceCny }}</div>

<div class="right" style="display: flex;flex: 1;align-items: center;min-width: 30%;">


  <div class="btn-box">
    <el-button type="primary" class="btn buy" :disabled="item.btnType == true"
      :class="[item.btnType == true ? 'hui' : '']" @click="buyCart(item, index)">加入购物车</el-button>

  </div>
</div>
</div>
</li>

<li v-if="active == 2" v-for="(item, index) in mation1" :key="index" class="list-item">
  <div class="right-item1" style="width: 100%;height: 100%;">
    <div class="left1" style="display: flex;align-items: center;width: 30%;">
      <template>

                    <div class="index1">{{ item.diagramNum }}</div>
                  </template>
      <div class="product-info1">
        <div class="name-info1">
          <p class="partName">{{ item.partName }}</p>
          <p>{{ item.partNumber }}</p>

        </div>
      </div>
      <div class="price" style="min-width: 30%;">￥{{ item.purchasePriceCny }}</div>
      <div v-if="active == 2" class="qqq">{{ item.mcSeriesModel.seriesModel
        }}-{{
        item.partCategory.categoryName }}</div>
    </div>
    <div class="right" style="display: flex;flex: 1;align-items: center;min-width: 30%;">
      <div class="num-box">
        <el-input-number v-model="item.buyNum" :min="item.minPurchaseQuantity" size="mini"
          @change="changeNum($event, item.minPurchaseQuantity, index,)"></el-input-number>

      </div>
      <div class="btn-box1">
        <el-button type="primary" class="btn buy" :disabled="item.btnType == true"
          :class="[item.btnType == true ? 'hui' : '']" @click="buyCart(item, index)">加入购物车</el-button>

      </div>
    </div>



  </div>
</li>
</ul>
<p v-if="loading">加载中...</p>
<p v-if="noMore">没有更多了</p>
</div>
</div>
</div> -->
  </div>
</template>

<script>
import Vehicle from './Vehicle'
import vin from './vin'
import contlist from './contlist'
import {
  addCart,
  listMcSeriesModels,
  pageQueryPart,
  pageQueryPartCategory,
  pageQueryParta,
  pageQueryParta1,
  listAccType,getInfo
} from "../../api/api";

export default {
  components: {
    Vehicle,
    vin,
    contlist,
  },
  data () {
    return {
      active: 0,
      list: [],
      mation: [],
      mation1: [],
      loading: false,
      mcSeriesModelId: 8,
      seriesModel: "",
      categoryId: "",
      categoryName: "",
      page: 1,
      totale: 0,
      url: '',
      show: false,
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      urlList: [],
      urlItem: '',
      acclist:[],
    };
  },
  created () {
    this.listMcSeriesModel();
    this.biao();
    this.acc()
  },
  computed: {
    noMore () {
      return this.page >= this.totale;
    },
    disabled () {
      return this.loading || this.noMore;
    },
  },
  watch: {
    mation1: {
      handler (newVal, oldVal) {
      },
      deep: true
    }
  },
  methods: {
      async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
      this.acclist = res.data
      // sessionStorage.setItem("token", res.token)
      // sessionStorage.setItem("userName", this.loginForm.username)
        this.info()

    },
     async info () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      
      console.log(123123);
      
      this.acclist.forEach(e => {
       
          
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.user.platform=='2') {
          sessionStorage.removeItem('shbz')
         
          sessionStorage.setItem("shbz", e.currencyType)
         
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.user.platform!=='2') {
          sessionStorage.removeItem('shbz')
       
          sessionStorage.setItem("shbz", e.currencyType)
          
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
         if (e.id == res.user.dealers[0].accTypeIdLs&&res.user.platform==2) {
          sessionStorage.removeItem('shbz')
          
          sessionStorage.setItem("shbz", e.currencyType)
         
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.user.platform!==2) {
          sessionStorage.removeItem('shbz')
        
          sessionStorage.setItem("shbz", e.currencyType)
          
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
      // sessionStorage.setItem("token", res.token)
      // sessionStorage.setItem("userName", this.loginForm.username)
   
    },
    changeNum (e, min, index) {
      console.log(e, index)
      if (e == min) {
        this.mation1[index].show = true
      }
      setTimeout(() => {
        this.mation1[index].show = false

      }, 5000);
      this.$forceUpdate()
    },
    setActive (num) {
      this.active = num
    },
    setImgUrl (url) {
      this.urlItem = url
    },
    buyCart (item, index) {
      this.mation1[index].btnType = true
      this.$forceUpdate()
      let param = new URLSearchParams();
      addCart(
        param,
        item.id,
        item.buyNum
      ).then(r => {
        console.log(r)
        if (r.data.code == 200) {
          this.$message.success(this.$t('menu.SUCESS'))
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        } else {
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        }
      })

    },
    changeCheXing (e) {
      this.mcSeriesModelId = e
      this.list.forEach(i => {
        if (i.id === e) {
          this.seriesModel = i.seriesModel
        }
      })
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = '';
      const { data: res } = await pageQueryPartCategory(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey
      );

      this.mation = res.data.list;

      this.categoryName = this.mation[0].categoryName;
      this.categoryId = this.mation[0].id;
      console.log(1);

      this.page = 1
      this.onsubtitle(this.categoryId, this.categoryName);
      // this.pageQueryParts()

    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      this.formInline.category = this.mcSeriesModelId
      this.seriesModel = this.list[0].seriesModel;
    },
    //配件查询
    async pageQueryParts () {
      let param = new URLSearchParams();
      console.log(this.categoryId);

      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;
      let categoryId = this.categoryId;
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        10,
        mcSeriesModelId,
        searchKey,
        this.categoryId
      );
      let arr = this.mation1
      this.mation1 = []
      res.data.list.forEach((e) => {
        e.buyNum = e.minPurchaseQuantity
        e.btnType = false
        e.show = false
        arr.push(e);
      });
      this.mation1 = arr
      console.log(66666666, this.mation1)
      if (this.totale !== res.data.pages) {
        this.totale = res.data.pages;
      }
    },
    async onsubtitle (e, i) {
      this.categoryId = e
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;
      let categoryId = e;
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        10,
        mcSeriesModelId,
        searchKey,
        categoryId
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });
      this.urlList = this.mation1[0].partCategory.diagramImageList.split(',')
      this.urlItem = this.urlList[0]
      if (this.totale !== res.data.pages) {
        this.totale = res.data.pages;
      }
      this.categoryName = i
    },
    load () {
      this.loading = true;
      if (this.mation1 >= this.totale == false) {
        setTimeout(() => {
          this.page++;
          this.pageQueryParts();
          this.loading = false;
        }, 2000);
      }
    },

    //搜索
    async onSubmit (num) {
      if (num == 1) {
        //配件查询
        this.page = 1
        let param = new URLSearchParams();
        let mcSeriesModelId = this.mcSeriesModelId;
        let searchKey = this.formInline.title;

        const { data: res } = await pageQueryParta1(
          param,
          this.page,
          10,
          mcSeriesModelId,
          searchKey
        );
        this.mation1 = res.data.list
        this.seriesModel = res.data.list[0].mcSeriesModel.seriesModel
        this.mcSeriesModelId = res.data.list[0].mcSeriesModel.id
        this.pageQueryParts()
        res.data.list.forEach((e, i) => {
          this.mation1[i].buyNum = e.minPurchaseQuantity

        });
        if (this.totale !== res.data.pages) {
          this.totale = res.data.pages;
        }

      } else {
        //配件查询
        this.page = 1
        let param = new URLSearchParams();
        let mcSeriesModelId = this.mcSeriesModelId;
        let searchKey = this.formInline.title;

        const { data: res } = await pageQueryParta(
          param,
          this.page,
          10,
          mcSeriesModelId,
          searchKey
        );
        this.mation1 = res.data.list
        res.data.list.forEach((e, i) => {
          this.mation1[i].buyNum = e.minPurchaseQuantity

        });
        if (this.totale !== res.data.pages) {
          this.totale = res.data.pages;
        }
      }


    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.list-item {
  width: 100%;
  height: 140px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.fg {
  border-bottom: 1px solid #f2f2f2;
  width: 100%;
  margin-bottom: 10px;
}

.name-info1 {
  display: flex;
  height: 40px;
  align-items: center;

  .partName {
    color: #222222;
    font-weight: 550;
    min-width: 200px;
  }
}

.name-info-1 {
  display: flex;
  justify-content: flex-start;
}

.right-item1 {
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.left {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 30%;
  padding-left: 20px;
}

.chexing {
  height: 30px;
  display: flex;
  align-items: center;
  border-left: 4px solid #409eff;
  padding-left: 20px;
  // margin-bottom: 10px;
}

.qqq {
  margin-left: 80px;
  min-width: 30%;
}

.acta {
  background-color: #beebff;
}

.img-item {
  width: 100px;
  height: 80px;
  cursor: pointer;
  border: 1px solid #eeeeee;
  margin-right: 20px;
}

.acttimg {
  border: 3px solid #409eff;
}

.leftbox {
  width: 28%;
  overflow-y: scroll;


  .big-pj {
    height: 40px;
    cursor: pointer;
    line-height: 40px;
  }
}

.rightbox {
  flex: 1;
  padding-left: 20px;
  padding: 0 0 40px 0;
  height: 100%;
}

.right-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.product-info1 {
  margin-left: 20px;
  display: flex;
  color: #999999;

  .name-info1 {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      margin-bottom: 10px;
    }
  }

}

.product-info {
  // margin-left: 20px;
  width: 300px;
  display: flex;
  justify-content: flex-start;
  color: #999999;

  .name-info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      // margin-bottom: 10px;
    }
  }

}

.right {
  justify-content: flex-end;
  margin-right: 40px;
  // margin-left: 40px;
}

.index1 {
  margin-left: 10px;
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.num-box1 {
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.num-box {
  // height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 70px;

  p {
    // margin-top: 10px;
  }
}

.active {
  color: #409eff;
}

.max-width {
  margin-left: 90px !important;
  // width: 40% !important;
}

.btn-box1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 300px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.center-box {
  width: 1700px;
}

/deep/ .el-image {
  width: 100%;
  height: 80%;
}

/deep/.el-input-number {
  width: 130px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #409eff;
  margin-top: 8px;
}

.index {
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs {
  display: flex;

  div {
    margin-right: 15px;
    cursor: pointer;

  }
}

.hui {
  background-color: #d7d7d7 !important;
  border: none !important;
}
</style>